import { useSelector } from "react-redux";

import { EntityTypesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import { getEmailTemplatesByEntityType } from "@app/store/email";

const useEntityTypeEmailTemplates = (entityType: EntityTypesSupportedByEmailFeature) => {
  return useSelector((state) => getEmailTemplatesByEntityType(state, entityType));
};

export default useEntityTypeEmailTemplates;
